import {createInitAjaxFormMap} from "./index";
import {createLeafletMap as createMap, getApi, loadLeafletMapsAPI} from "@elements/leaflet-map";

export function apiLoaded(){
    return loadLeafletMapsAPI();
}

export const initAjaxFormMap = createInitAjaxFormMap({createMap, getApi});